<template>
  <home-floating-window
    :title="$t('Processing')"
    @close="closeProcessing"
    :pos-x="position.x"
    :pos-y="position.y"
    :draggable="!loading"
    style="overflow: scroll"
  >
    <template v-slot:iconWindows>
      <ProcessingSVG class="floating-container-svg" />
    </template>

    <template v-slot:objectDivWindows>
      <processing-list
        :processing-items="preProcessingList"
        @run-processing="executeProcessing('pre', $event)"
        @change-to-default="changeToDefault($event, 'pre')"
        :pr_code="pr_code_pre"
      />

      <v-divider v-if="disableDivider" style="margin: 0 20px" />

      <processing-list
        :processing-items="postProcessingList"
        @run-processing="executeProcessing('post', $event)"
        @change-to-default="changeToDefault($event, 'post')"
        :pr_code="pr_code_post"
      />


      <loading-spinner
        :active.sync="loading"
        :is-full-page="true"
        color="#4fa2b7"
        :height="30"
        :width="30"
      />
    </template>
  </home-floating-window>
</template>

<script>
import { mapActions } from "vuex";
import LoadingSpinner from "vue-loading-overlay";
import 'vue-loading-overlay/dist/vue-loading.css';
import HomeFloatingWindow from "@/components/Home/Content/ObjectWindow/HomeFloatingWindow";
import ProcessingList from "@/components/Home/Content/ObjectWindow/Processing/ProcessingList";
import ProcessingSVG from "@/assets/cable_menu/processing_window.svg";

export default {
  name: "ProcessingWindow",


  components: {
    ProcessingList,
    HomeFloatingWindow,
    ProcessingSVG,
    LoadingSpinner,
  },


  props: {
    position: Object
  },

  data() {
    return {
      processingList: null,
      preProcessingList: [],
      postProcessingList: [],

      waitingList: [],

      pr_code_pre: undefined,
      pr_code_post: undefined,

      loading: false,
    };
  },

  mounted() {
    this.getProcessingByType();
  },

  methods: {
    ...mapActions([
      "fetchProcessingList",
      "SET_TOOL_ACTION",
      "runProcessing",
      "setOpenHomeSidebar"
    ]),

    closeProcessing() {
      this.SET_TOOL_ACTION("");
      this.setOpenHomeSidebar("");
    },

    async getProcessingByType() {

        try {
        this.processingList = await this.fetchProcessingList();
        if (this.processingList["PRE"]) {
          for (const item of this.processingList["PRE"]) {
            this.preProcessingList.push(item);
          }
        }
        if (this.processingList["POS"]) {
          for (const item of this.processingList["POS"]) {
            this.postProcessingList.push(item);
          }
        }
      } catch (error) {
        console.error(error);
      }
    },

    executeProcessing(list, processingItem) {

      if (processingItem) {
        this.waitingList.push({
          list: list,
          index: processingItem.index,
          data: processingItem.data
        });
        if (list === "pre") {
          this.preProcessingList[processingItem.index].state = "waiting";
        } else {
          this.postProcessingList[processingItem.index].state = "waiting";
        }
        if (this.waitingList.length === 1) {
          this.runNextWaitingListItem();
        }
      }
    },

    runNextWaitingListItem() {
      let waitingListItem = this.waitingList[0];
      let processingItem;
      if (waitingListItem.list === "pre") {
        processingItem = this.preProcessingList[waitingListItem.index];
        this.preProcessingList[waitingListItem.index].dataToSend =
          waitingListItem.data;
      } else {
        processingItem = this.postProcessingList[waitingListItem.index];
        this.postProcessingList[waitingListItem.index].dataToSend =
          waitingListItem.data;
      }
      processingItem.state = "running";
      this.runProcessingItem(processingItem, waitingListItem.data);
    },

    runProcessingItem(processingItem, dataToSend) {
      this.loading=true;
      this.runProcessing({ endpoint: processingItem.pr_code, data: dataToSend })
        .then(resp => {
          processingItem["numberOfObjects"] = resp.data.data;
          if (!dataToSend["apply"]) {
            processingItem.state = "warning";
          } else {
            processingItem.state = "success";
          }
        })
        .catch(error => {
          processingItem.state = "fail";
          console.log(error);
          this.loading=false;
        })
        .then(() => {
          this.waitingList.splice(0, 1);
          if (processingItem.pr_type === "PRE") {
            this.pr_code_pre === processingItem.pr_code
              ? (this.pr_code_pre = "")
              : (this.pr_code_pre = processingItem.pr_code);
          } else {
            this.pr_code_post === processingItem.pr_code
              ? (this.pr_code_post = "")
              : (this.pr_code_post = processingItem.pr_code);
          }
          if (this.waitingList.length > 0) {
            this.runNextWaitingListItem();
          }
        })
        .then(()=>{
          this.$emit('update-geoserver');
          this.loading=false;
        })
    },

    changeToDefault(field, list) {
      this.loading = false;
      if (list === "pre") {
        this.pr_code_pre = null;
        this.preProcessingList[field].state = "default";
      } else {
        this.pr_code_post = null;
        this.postProcessingList[field].state = "default";
      }
    },

    disableDivider() {
      return (
        this.preProcessingList.length === 0 ||
        this.postProcessingList.length === 0
      );
    },

  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Content/ObjectWindow/Processing/ProcessingWindow.vue